const PAL_PATTERNS = [
    { pattern: /may contain traces of\s+(.+?)(?:\.|,|$)/gi, severity: 'advisory' },
    { pattern: /may contain\s+(.+?)(?:\.|,|$)/gi, severity: 'advisory' },
    { pattern: /manufactured in a facility that (?:also )?processes?\s+(.+?)(?:\.|,|$)/gi, severity: 'precautionary' },
    { pattern: /produced in a facility that (?:also )?processes?\s+(.+?)(?:\.|,|$)/gi, severity: 'precautionary' },
    { pattern: /made on equipment that (?:also )?processes?\s+(.+?)(?:\.|,|$)/gi, severity: 'precautionary' },
    { pattern: /manufactured on shared equipment with\s+(.+?)(?:\.|,|$)/gi, severity: 'precautionary' },
    { pattern: /may be present\s*:?\s*(.+?)(?:\.|,|$)/gi, severity: 'advisory' },
    { pattern: /could contain\s+(.+?)(?:\.|,|$)/gi, severity: 'informational' },
];
export function detectPAL(text) {
    const detections = [];
    const seen = new Set();
    let counter = 0;
    for (const { pattern, severity } of PAL_PATTERNS) {
        for (const match of text.matchAll(pattern)) {
            const statement = match[0].trim();
            const normalized = statement.toLowerCase().replace(/\s+/g, ' ');
            if (seen.has(normalized))
                continue;
            seen.add(normalized);
            const allergensText = match[1]?.trim() ?? '';
            const referencedAllergens = allergensText
                .split(/[,;]\s*/)
                .map((a) => a.trim().toLowerCase())
                .filter((a) => a.length > 0);
            detections.push({
                id: `pal-${counter++}`,
                statement,
                pattern: pattern.source,
                referencedAllergens,
                severity,
            });
        }
    }
    return detections;
}
//# sourceMappingURL=palDetector.js.map